module.exports = "../static/media/official.254871e7.png";